import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Campaign = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 28 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_1357_13248)">
        <path
          d="M21.3188 13.221L18.9933 8.10925C18.6952 7.45411 17.8235 7.3189 17.341 7.85298L14.2497 11.2749C14.1923 11.3384 14.1433 11.4091 14.1039 11.4851L10.5999 18.2456C10.2303 18.9588 10.8099 19.7947 11.6074 19.6986L16.126 19.1542C16.205 19.1447 16.2849 19.1446 16.364 19.154L18.7364 19.437C19.2111 19.4936 19.6594 19.2064 19.8064 18.7515L21.3601 13.9426C21.4368 13.7053 21.422 13.448 21.3188 13.221Z"
          fill="white"
        />
        <path
          d="M15.7717 13.3096C14.539 15.4448 13.0674 17.1343 11.7116 18.1486C11.0326 18.6566 10.4107 18.9743 9.88581 19.1112C9.36505 19.2471 8.99003 19.1947 8.72421 19.0412C8.45839 18.8878 8.22555 18.5892 8.08283 18.0702C7.939 17.5472 7.90312 16.8498 8.00354 16.0078C8.20408 14.3264 8.93144 12.2073 10.1642 10.0721C11.397 7.93689 12.8685 6.24741 14.2243 5.23307C14.9033 4.72508 15.5253 4.40745 16.0501 4.27051C16.5709 4.13465 16.9459 4.18699 17.2117 4.34046C17.4775 4.49393 17.7104 4.79254 17.8531 5.31146C17.9969 5.83446 18.0328 6.53187 17.9324 7.3739C17.7318 9.05526 17.0045 11.1744 15.7717 13.3096Z"
          fill="white"
          stroke={color}
          strokeWidth="1.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1222 6.89797C17.9677 6.2693 17.7572 5.76806 17.3961 5.36074L18.3688 4.4983C18.9254 5.12607 19.2045 5.85478 19.3847 6.58767C19.4936 7.03088 19.5765 7.53076 19.6575 8.01958L19.6575 8.01961C19.7035 8.2971 19.7489 8.57104 19.7982 8.82902C20.05 10.148 20.464 11.5073 21.7525 12.8108C22.8549 13.8624 23.9815 14.5128 25.108 15.1632L25.1079 15.1633L25.1082 15.1635C26.1544 15.7674 26.2188 17.6142 25.2522 19.2883C24.4054 20.755 23.048 21.6027 22.0212 21.384L21.9865 21.4443C20.5852 21.5348 19.1373 22.3993 18.2905 24.7682C18.1063 25.2834 17.5781 25.6128 17.0456 25.487L14.8694 24.9727C14.2175 24.8186 13.9195 24.0895 14.3602 23.585C14.7968 23.0853 15.3774 22.5266 16.0692 22.0697C15.3448 21.6515 15.6154 20.5763 16.2163 19.7685C15.2949 19.7049 14.291 19.9128 13.1987 20.1478L13.188 20.1501L13.188 20.1501C12.4455 20.3099 11.658 20.4793 10.9083 20.5174C10.1458 20.5562 9.36244 20.4638 8.64682 20.0507L9.29685 18.9249C9.71783 19.1679 10.2224 19.2507 10.8423 19.2192C11.4715 19.1872 12.1567 19.0423 12.9253 18.8769L13.0263 18.8552C14.4356 18.5514 16.1338 18.1853 17.713 18.7639C20.0594 18.2037 20.7539 15.9179 20.7767 13.6725C19.2814 12.135 18.7971 10.5176 18.5212 9.07284C18.4576 8.73955 18.4077 8.43553 18.3606 8.14884L18.3606 8.14882L18.3606 8.14881C18.2878 7.70516 18.2218 7.30298 18.1222 6.89797Z"
          fill={color}
        />
        <path
          d="M8.44076 9.03516L5.19111 6.77965C4.80416 6.51107 4.2703 6.63058 4.03479 7.0385C3.79928 7.44642 3.96271 7.96851 4.38878 8.16933L7.96693 9.85586C8.19062 9.96129 8.45778 9.87766 8.58142 9.6635C8.70507 9.44935 8.64391 9.17616 8.44076 9.03516Z"
          fill={color}
        />
        <path
          d="M11.5475 5.46318L9.86097 1.88502C9.66015 1.45895 9.13806 1.29552 8.73014 1.53104C8.32222 1.76655 8.20271 2.30041 8.47129 2.68736L10.7268 5.93701C10.8678 6.14016 11.141 6.20131 11.3551 6.07767C11.5693 5.95403 11.6529 5.68686 11.5475 5.46318Z"
          fill={color}
        />
        <path
          d="M6.54411 13.1815L2.60208 12.853C2.13268 12.8139 1.7301 13.1843 1.7301 13.6554C1.7301 14.1264 2.13268 14.4968 2.60208 14.4577L6.54411 14.1292C6.79055 14.1087 6.9801 13.9027 6.9801 13.6554C6.9801 13.4081 6.79055 13.2021 6.54411 13.1815Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8198 15.0522C13.3176 14.4439 13.8102 13.732 14.2648 12.9447C14.7193 12.1575 15.0895 11.3749 15.3674 10.6396C14.2357 10.3141 12.9857 10.7851 12.3703 11.851C11.755 12.9168 11.972 14.2349 12.8198 15.0522Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1357_13248">
          <rect width="28" height="28" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Campaign
